export const convertNumberMonthsToString = (num: string): string => {
    const monthMap: { [key: string]: string } = {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'March',
        '04': 'Apк',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sept',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec',
    };

    return monthMap[num] || 'Invalid month';
};